<template>
  <div class="content">
    <NavBar :navBlock="navBlock" :navtitle="navtitle"></NavBar>
    <div class="paddingContent">
      <div style="display: flex;">
        <span style="font-size: 14px;font-weight: bold;">{{
          mangerdata.activityName
        }}</span>
        <el-tooltip
          class="item"
          effect="dark"
          content="活動核銷時間結束後管理員會自動解除權限"
          placement="bottom"
        >
          <i class="el-icon-warning" style="font-size: 20px;"></i>
        </el-tooltip>
      </div>
      <div style="display: flex;justify-content: end;">
        <div class="buttons" @click="getexcel()">
          批量上傳
        </div>
        <div class="buttons" style="margin-left: 20px;" @click="getadd()">
          新增
        </div>
      </div>
      <div class="tableWrap">
        <el-table
          height="660px"
          stripe
          :data="activityList"
          style="width:100%;"
        >
          <template slot="empty">
            <div class="no-data-container">
              <img
                src="@/assets/images/common/no_data.png"
                alt="暫無數據"
                :style="{ width: '244px', height: '139px' }"
              />
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in activityTable"
            :key="index"
            :prop="item.prop"
            :label="item.label"
          >
          </el-table-column>
          <el-table-column label="操作" width="300" fixed="right">
            <template slot-scope="scope">
              <el-button
                @click="delActivity(scope.row.id)"
                type="text"
                :disabled="scope.row.type == 1"
                >刪除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination
          class="paging fr"
          hide-on-single-page
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count="5"
          layout="prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="新增"
      :visible.sync="centerDialogVisible"
      width="35%"
      :close-on-click-modal="false"
      center
    >
      <div v-if="stepnext">
        <div class="flexBox">
          <span>賬號：</span>
          <el-input
            style="width: 230px;"
            v-model="acount"
            placeholder="請輸入賬號"
          ></el-input>
        </div>
        <div class="flexBox" style="margin-top: 50px;">
          <div class="buttons" @click="getSumbit('cancel')">
            取消
          </div>
          <div
            class="buttons"
            v-throttle="{
              fn: () => {
                getSumbit('next');
              },
              time: 2000
            }"
            style="margin-left: 20px;background: #6c3dea;color: #FFFFFF;"
          >
            下一步
          </div>
        </div>
      </div>
      <div v-else class="flexBox" style="flex-direction: column;">
        <div style="width: 60%;">
          <div style="margin-top: 20px;">
            <span>賬號：{{ userinfo.username }}</span>
          </div>
          <div style="margin-top: 20px;">
            <span>昵稱：{{ userinfo.nickname }}</span>
          </div>
          <div style="display: flex;margin-top: 20px;">
            <span
              >備注：<el-input
                style="width: 230px;"
                v-model="remark"
                placeholder="請輸入備注"
              ></el-input
            ></span>
          </div>
        </div>
        <div class="flexBox" style="margin-top: 50px;">
          <div class="buttons" @click="getSumbit('back')">
            取消
          </div>
          <div
            class="buttons"
            v-throttle="{
              fn: () => {
                getSumbit('add');
              },
              time: 3000
            }"
            style="margin-left: 20px;background: #6c3dea;color: #FFFFFF;"
          >
            增加
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="上傳名单"
      :visible.sync="uoloadModal"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="500px"
      center
    >
      <div style="display:flex;justify-content: flex-end;">
        <div
          v-throttle="{ fn: download, time: 3000 }"
          style="color:#6c3dea;text-align:right;font-size:14px;cursor:pointer"
        >
          下載模版
        </div>
      </div>
      <div class="dialog">
        <div>
          <el-upload
            ref="excelUpload"
            :action="this.$GLOBAL.managerPostUrl"
            :with-credentials="true"
            class="upload-demo"
            :headers="{ Authorization: this.$cookie.get('auth') }"
            drag
            :accept="'.xlsx,.xls'"
            :multiple="false"
            :file-list="fileList"
            :on-change="fileChange"
            :on-success="successExcel"
            :on-error="errorExcel"
            :auto-upload="false"
            :data="{
              activityId: this.mangerdata.id
            }"
            name="file"
          >
            <img
              src="@/assets/images/common/blacklist_upload.png"
              alt="暂无数据"
              :style="{
                width: '41px',
                height: '41px',
                marginTop: '40px',
                marginBottom: '14px'
              }"
            />
            <div class="el-upload__text">
              將文件拖到此處，或<em>點擊上傳</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              只能上傳單個xlsx/xls文件，並且只根據上傳內容進行更新
            </div>
          </el-upload>
          <div class="btngroup">
            <div
              class="btn borderBtn"
              style="margin-right:112px"
              @click="uoloadModal = false"
            >
              取消
            </div>
            <div class="btn" @click="submitupdate">确认更新</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";
import { Indicator } from "mint-ui";
export default {
  data() {
    return {
      navBlock: "活動 / 核銷活動",
      navtitle: "管理員",
      activityList: [],
      stepnext: true,
      centerDialogVisible: false,
      acount: "",
      uoloadModal: false,
      remark: "",
      userinfo: {},
      activityTable: [
        {
          prop: "username",
          label: "會員賬號"
        },
        {
          prop: "remark",
          label: "備注"
        }
      ],
      currentPage: 1, // 分页
      total: 0,
      dialogVisible: false,
      mangerdata: {},
      fileList: []
    };
  },
  created() {
    this.mangerdata = JSON.parse(decodeURIComponent(this.$route.query.params));

    this.getActivityList();
  },
  submitupdate() {
    this.$refs.excelUpload.submit();
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    // 上传名单
    fileChange(file, fileList) {
      this.fileList = [];
      this.fileList.push(file);
    },
    successExcel(res, file, fileList) {
      let _this = this;
      Indicator.close();
      _this.$nextTick(() => {
        if (res.code === "00000") {
          _this.$refs.excelUpload.clearFiles();
          _this.fileList = [];
          _this.uoloadModal = false;
          _this.$message({
            message: "名單上傳成功",
            type: "success",
            center: true
          });
          _this.currentPage = 1;
          _this.getActivityList();
        } else {
          _this.$refs.excelUpload.clearFiles();
          _this.fileList = [];
          _this.uoloadModal = false;
          _this.$propMessage(res.message, "error", () => {});
        }
      });
    },
    errorExcel(err, file, fileList) {
      Indicator.close();
      this.$nextTick(() => {
        let _this = this;
        _this.$refs.excelUpload.clearFiles();
        _this.fileList = [];
        _this.dialogVisible = true;
        _this.$propMessage(err.message + ",請重新上傳", "error", function() {
          _this.dialogVisible = false;
        });
      });
    },
    submitupdate() {
      let _this = this;
      if (_this.fileList.length == 0) {
        _this.dialogVisible = true;
        _this.$propMessage("请上傳名單", "error", function() {
          _this.dialogVisible = false;
        });
        return;
      }
      Indicator.open("數據處理中，請耐心等待");
      this.$refs.excelUpload.submit();
    },
    download() {
      window.open(
        "https://start.sanctuarytech.co/resource/excel/Write-off_Manager.xlsx"
      );
    },
    // 获取活动列表信息
    getActivityList() {
      this.$get(
        `/write/off/activity/manager/list?page=${this.currentPage}&size=10&activityId=${this.mangerdata.id}`,
        this.$GLOBAL.jsonConfig
      ).then(res => {
        if (res.code === "00000") {
          this.activityList = res.data.list;
          this.total = res.data.total;
          console.log(this.activityList);
        } else {
          this.$propMessage(res.message, "error");
        }
      });
    },
    getexcel() {
      this.uoloadModal = true;
    },
    getadd() {
      this.acount = "";
      this.remark = "";
      this.centerDialogVisible = true;
      this.stepnext = true;
    },
    getSumbit(type) {
      if (type === "cancel") {
        this.centerDialogVisible = false;
      } else if (type === "next") {
        if (this.acount === "") {
          this.$message({
            message: "請輸入賬號",
            type: "warning",
            center: true
          });
          return;
        } else {
          this.$get(
            `/write/off/activity/manager?username=${this.acount}`,
            this.$GLOBAL.jsonConfig
          )
            .then(res => {
              if (res.code == "00000") {
                this.stepnext = false;
                this.userinfo = res.data;
              } else {
                this.$message({
                  message: res.message,
                  type: "warning",
                  center: true
                });
              }
            })
            .catch(err => {
              this.$propMessage(err.message);
            });
        }
      } else if (type === "back") {
        this.stepnext = true;
      } else if (type === "add") {
        this.$post(
          `/write/off/activity/manager`,
          {
            activityId: this.mangerdata.id,
            username: this.acount,
            remark: this.remark
          },
          this.$GLOBAL.jsonConfig
        )
          .then(res => {
            if (res.code == "00000") {
              this.$message({
                message: "管理員增加成功",
                type: "success",
                center: true
              });
              this.centerDialogVisible = false;
              this.currentPage = 1;
              this.getActivityList();
            } else {
              this.$message({
                message: res.message,
                type: "warning",
                center: true
              });
            }
          })
          .catch(err => {
            this.$propMessage(err, "error");
          });
      }
    },
    // 分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getActivityList();
    },
    // 删除活动
    delActivity(id) {
      let _this = this;
      _this
        .$del(`/write/off/activity/manager/${id}`, _this.$GLOBAL.jsonConfig)
        .then(res => {
          _this.dialogVisible = true;
          if (res.code === "00000") {
            _this.dialogVisible = false;
            _this.currentPage = 1;
            _this.getActivityList();
          } else {
            _this.$propMessage(res.message, "error", function() {
              _this.dialogVisible = false;
            });
          }
        });
    },

    navigateDraw(res) {
      if (res.applyStatus == "報名階段") {
        let url = `/request/apply/export/excel`;
        let date = new Date();
        this.$exportExcel(
          url,
          "POST",
          {
            applyId: res.id
          },
          "用戶報名資料" + this.$formatDate(date).substring(0, 10)
        );
        return;
      }
      this.$get(
        `/request/apply/getApplyStatus?applyId=${res.id}`,
        this.$GLOBAL.jsonConfig
      ).then(result => {
        if (result.code == "00000") {
          if (result.data.applyStatus == "3") {
            if (result.data.jump) {
              //手动抽选页面
              this.$router.push(`/activityDrawList?id=${result.data.id}`);
              this.$bus.$emit("activityDrawinit");
            } else {
              //抽选条件页面
              this.$router.push(
                `/activityDrawFirst?id=${result.data.id}&selectionType=${result.data.selectionType}`
              );
            }
          } else if (result.data.applyStatus == "4") {
            this.$router.push(`/activityDrawConfirmList?id=${result.data.id}`);

            this.$bus.$emit("activityDrawinitList");
            this.$bus.$emit("activityDrawConfirminit");
          } else if (result.data.applyStatus == "5") {
            //最后调整页面
            this.$router.push(`/activityDrawConfirmList?id=${result.data.id}`);
            this.$bus.$emit("activityDrawinitList");
            this.$bus.$emit("activityDrawConfirminit");
            // this.$bus.$emit('activityDrawConfirminitNull')
          }
        } else {
          this.dialogVisible = true;
          this.$propMessage(result.message, "error", () => {
            this.dialogVisible = false;
          });
        }
      });
    }
  },
  components: {
    NavBar,
    DiaMess
  }
};
</script>
<style lang="less" scoped>
.buttons {
  margin-top: 20px;
  width: 100px;
  height: 35px;
  text-align: center;
  line-height: 35px;
  border-radius: 5px;
  font-size: 14px;
  border: 1px solid;
  cursor: pointer;
}
.flexBox {
  display: flex;
  justify-content: center;
  align-items: center;
}
.dialog {
  display: flex;
  justify-content: center;
  max-height: 80vh;
  overflow-y: auto;
  .el-upload__tip {
    color: #65676b;
  }
  .dialogrow {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    /deep/ .el-checkbox {
      width: 150px !important;
      text-align: left;
      display: block !important;
      margin-right: 0px !important;
    }
    /deep/ .el-input {
      width: 190px !important;
    }
    .badgeadd {
      width: 80px;
      color: rgba(147, 144, 163, 1);
      background: rgba(242, 240, 247, 1);
      text-align: center;
      cursor: pointer;
      line-height: 36px;
      margin-left: 9px;
      border-radius: 6px;
    }
    .badgedelete {
      width: 80px;
      text-align: center;
      color: #6c3dea;
      line-height: 36px;
      margin-left: 9px;
      cursor: pointer;
    }
  }
}
.btngroup {
  margin-top: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  .btn {
    text-align: center;
  }
}
/deep/ .el-dialog {
  border-radius: 12px;
}
/deep/ .el-dialog__header {
  //   box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
}
/deep/ .el-dialog__title {
  font-size: 0.16rem;
}
/deep/ .el-upload__text em {
  color: #6c3dea !important;
}
/deep/ .el-upload-dragger:hover {
  border-color: #6c3dea !important;
}
/deep/ .el-upload-dragger {
  width: 320px !important;
  border: 1px dashed #d9d9d9 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/checkActivity/mangerList.vue